export const ServicesOverview = () => {
  const services = [
    {
      title: "Paket Umroh",
      desc: "Pilihan paket umroh dengan jadwal keberangkatan terjadwal.",
      link: "#packages",
      action: "Lihat Paket →",
    },
    {
      title: "Haji Khusus",
      desc: "Program haji khusus resmi dengan pelayanan premium.",
      link: "#haji-khusus",
      action: "Selengkapnya →",
    },
    {
      title: "Umroh Custom",
      desc: "Perjalanan ibadah yang disesuaikan kebutuhan jamaah.",
      link: "#umroh-custom",
      action: "Selengkapnya →",
    },
    {
      title: "Visa Umroh",
      desc: "Provider Visa Umroh Resmi MOFA Saudi Arabia.",
      link: "#visa-umroh",
      action: "Selengkapnya →",
    },
  ];

  return (
    <section
      id="layanan"
      className="scroll-mt-32 py-16 md:py-24 bg-[color:var(--bg)]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">

        <div className="text-center max-w-3xl mx-auto mb-10">
          <div className="text-sm uppercase tracking-[0.22em] text-accent font-semibold">
            Layanan Utama Baba Tour
          </div>

          <h2 className="font-serif-display text-primary text-3xl md:text-5xl mt-4">
            Temukan Layanan Sesuai Kebutuhan Anda
          </h2>

          <p className="text-muted mt-4">
            Seluruh layanan kami dirancang untuk memberikan
            kenyamanan dan ketenangan dalam perjalanan ibadah Anda.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4 md:gap-6">

          {services.map((item) => (
            <a
              key={item.title}
              href={item.link}
              className="
                bg-white
                rounded-3xl
                border
                border-soft
                p-5
                md:p-8
                hover:shadow-xl
                hover:-translate-y-1
                transition-all
                duration-300
                flex
                flex-col
                min-h-[190px]
                md:min-h-[240px]
              "
            >
              <div className="text-accent text-base mb-3">
                ✦
              </div>

              <h3 className="font-serif-display text-primary text-lg md:text-2xl leading-tight">
                {item.title}
              </h3>

              <p className="text-muted text-sm md:text-base mt-3 leading-relaxed flex-grow">
                {item.desc}
              </p>

              <div className="mt-4 text-sm md:text-base text-accent font-medium">
                {item.action}
              </div>
            </a>
          ))}

        </div>

      </div>
    </section>
  );
};
